import type { DifficultyId, DifficultyPreset } from "./Difficulty";

export type PenanggalCombatPhase="APPROACH"|"SPRAY_RECOIL"|"RETREAT"|"SIDE_EVADE"|"COUNTERATTACK"|"RECOVERY"|"VULNERABLE";

export interface PenanggalCombatTuning{
  readonly sprayExposureSeconds:number;
  readonly sprayDamageCooldownSeconds:number;
  readonly recoilSeconds:number;
  readonly reactionCooldownSeconds:number;
  readonly retreatDistance:number;
  readonly sideEvadeDistance:number;
  readonly evadeSpeedMultiplier:number;
  readonly counterattackSpeedMultiplier:number;
  readonly counterattackWindupSeconds:number;
  readonly vulnerabilitySeconds:number;
  readonly maximumConsecutiveEvasions:number;
}

export const PENANGGAL_COMBAT_TUNING:Readonly<Record<DifficultyId,PenanggalCombatTuning>>={
  jinak:{sprayExposureSeconds:.4,sprayDamageCooldownSeconds:1.34,recoilSeconds:.28,reactionCooldownSeconds:4.8,retreatDistance:1,sideEvadeDistance:.75,evadeSpeedMultiplier:.72,counterattackSpeedMultiplier:.86,counterattackWindupSeconds:.62,vulnerabilitySeconds:1.5,maximumConsecutiveEvasions:1},
  nakal:{sprayExposureSeconds:.4,sprayDamageCooldownSeconds:1.7,recoilSeconds:.26,reactionCooldownSeconds:4.2,retreatDistance:1.15,sideEvadeDistance:.9,evadeSpeedMultiplier:.82,counterattackSpeedMultiplier:.96,counterattackWindupSeconds:.56,vulnerabilitySeconds:1.35,maximumConsecutiveEvasions:1},
  liar:{sprayExposureSeconds:.4,sprayDamageCooldownSeconds:2,recoilSeconds:.24,reactionCooldownSeconds:3.7,retreatDistance:1.35,sideEvadeDistance:1.05,evadeSpeedMultiplier:.94,counterattackSpeedMultiplier:1.08,counterattackWindupSeconds:.5,vulnerabilitySeconds:1.2,maximumConsecutiveEvasions:2},
  rakus:{sprayExposureSeconds:.35,sprayDamageCooldownSeconds:1.27,recoilSeconds:.22,reactionCooldownSeconds:3.1,retreatDistance:1.55,sideEvadeDistance:1.25,evadeSpeedMultiplier:1.08,counterattackSpeedMultiplier:1.22,counterattackWindupSeconds:.44,vulnerabilitySeconds:1.05,maximumConsecutiveEvasions:2},
  buang_tebiat:{sprayExposureSeconds:.35,sprayDamageCooldownSeconds:1.12,recoilSeconds:.2,reactionCooldownSeconds:2.7,retreatDistance:1.8,sideEvadeDistance:1.45,evadeSpeedMultiplier:1.2,counterattackSpeedMultiplier:1.35,counterattackWindupSeconds:.38,vulnerabilitySeconds:.95,maximumConsecutiveEvasions:2},
};

export function penanggalCombatTuning(difficulty:Pick<DifficultyPreset,"id">):PenanggalCombatTuning{return PENANGGAL_COMBAT_TUNING[difficulty.id];}

/** Continuous unobstructed contact estimate; evasions intentionally increase real elapsed fight time. */
export function estimatePenanggalSprayContactSeconds(hitPoints:number,tuning:PenanggalCombatTuning):number{
  const hits=Math.max(0,Math.floor(hitPoints));
  return hits===0?0:tuning.sprayExposureSeconds+(hits-1)*tuning.sprayDamageCooldownSeconds;
}
